// const GOOGLE_API_KEY = "AIzaSyATI2wtUH_4nGblRtHR0yg8v55Kl6hRrbc";

//const YOUTUBE_API_KEY =  "https://www.googleapis.com/youtube/v3/videoCategories?part=snippet&regionCode=US&key=AIzaSyATI2wtUH_4nGblRtHR0yg8v55Kl6hRrbc";
const YOUTUBE_API_KEY =
  "https://youtube.googleapis.com/youtube/v3/videos?part=snippet%2CcontentDetails%2Cstatistics&chart=mostPopular&maxResults=50&regionCode=US&key=AIzaSyATI2wtUH_4nGblRtHR0yg8v55Kl6hRrbc";
export const YOUTUBE_SEARCH_API = "http://suggestqueries.google.com/complete/search?client=firefox&ds=yt&q=";

export default YOUTUBE_API_KEY;
